import { useState } from "react";
import { useFetchFolderDataSources } from "services";
import DataSourceComponent from "../DataSourceComponent";
import { Modal, Pagination } from "components/shared";
import { IDataSource } from "types";
import Loading from "components/shared/Loading";
import Typography from "components/shared/Typography";
import classNames from "classnames";
import EmptyFolder from "./EmptyFolder";
import CreateFolderModal from "../modals/CreateFolderModal";

export default function Folders() {
  const [currentPage, setCurrentPage] = useState<number>(1);

  const { data: folderData, isFetching, error } = useFetchFolderDataSources(String(currentPage));

  const folderDataSources = folderData?.data?.folders as Partial<IDataSource>[];

  const displayNoDataSourcesAvailable = folderData && folderData.data.folders.length === 0 && !isFetching;

  const total = folderData?.data.total as number;

  const dataSources = folderData?.data?.folders as Partial<IDataSource>[];

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const [createFolderModalOpen, setCreateFolderModalOpen] = useState<boolean>(false);

  const displayDataSources = dataSources && dataSources.length > 0 && !isFetching;

  return (
    <div>
      {createFolderModalOpen && (
        <Modal
          onClose={() => setCreateFolderModalOpen(false)}
          open={modalOpen}
          variant="full"
          children={<CreateFolderModal onClose={() => setCreateFolderModalOpen(false)} />}
        />
      )}
      {error && (
        <div className="mt-40 w-full flex justify-center items-center">
          <Typography variant="displaysm" weight="semibold" className="text-shade-black text-center">
            There was an unexpected error while retrieving data sources
          </Typography>
        </div>
      )}
      {isFetching && (
        <div className={classNames("h-full mt-2 w-[700px]")}>
          <Loading numberOfLoaders={5} className="bg-grey-200 !h-20" />
        </div>
      )}
      {displayNoDataSourcesAvailable && <EmptyFolder empty={false} setOpen={setCreateFolderModalOpen} />}

      {displayDataSources && (
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-5">
            {folderDataSources?.map((dataSource) => (
              <div key={dataSource.id}>
                <DataSourceComponent
                  name={dataSource.name as string}
                  id={dataSource.id as string}
                  updated={dataSource.updated as string}
                  type={dataSource.type as string}
                  origin={dataSource.origin as string}
                  status={dataSource.status as string}
                />
              </div>
            ))}
            {total && total > 10 && (
              <div className="mt-2">
                <Pagination onChangePage={setCurrentPage} pageSize={10} currentPage={currentPage} total={total || 0} />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
